import React, { Component } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import ListItem from "@material-ui/core/ListItem";
import { connect } from "react-redux";

class LoadingCell extends Component {
  render() {
    const { language } = this.props;
    return (
      <div>
        <ListItem
          className="ml-0"
          button
          style={{
            flexDirection: language == "english" ? "row" : "row-reverse",
          }}
        >
          <Skeleton
            variant="rect"
            height={90}
            style={{
              borderRadius: 8,
              minWidth: 90,
              maxWidth: 90,
              backgroundColor: "#c3c3c3",
            }}
          />
          <div className="mx-3 w-100">
            <Skeleton
              style={{
                marginBottom: 10,
                float: language == "english" ? "left" : "right",
                width: `${Math.floor(Math.random() * (100 - 25) + 25)}%`,
                backgroundColor: "#c3c3c3",
              }}
            />
            <br />
            <Skeleton style={{ backgroundColor: "#c3c3c3" }} />
            <Skeleton
              style={{
                marginBottom: 10,
                float: language == "english" ? "left" : "right",
                width: `${Math.floor(Math.random() * (100 - 30) + 30)}%`,
                backgroundColor: "#c3c3c3",
              }}
            />
            <br />
            <Skeleton
              width={60}
              style={{
                float: language == "english" ? "right" : "left",
                position: "relative",
                top: 8,
                backgroundColor: "#c3c3c3",
              }}
            />
          </div>
        </ListItem>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

export default connect(mapStateToProps)(LoadingCell);
